export const WHATS_NEW_FEATURES = [
  {
    name: 'chatbot',
    title: 'Introducing the ACT AI Customer Service Chatbot',
    description:
      'A new AI-powered chat assistant is now available on test event and room pages. ' +
      'Click the chat icon in the bottom right to get help during your event.',
  },
];
